import DropupKeywordResponses from './DropupKeywordResponses';
import './DropupKeywordResponses.scss';

export default DropupKeywordResponses;
